import { render, staticRenderFns } from "./tax-forms.page.vue?vue&type=template&id=387f430c&"
import script from "./tax-forms.page.vue?vue&type=script&lang=ts&"
export * from "./tax-forms.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports